/**
 * iOS 影子音频：视频模式下用静音的 audio 元素同步播放，避免锁屏后无声
 * 抽离自 MusicPlayer.js togglePlay
 */
import { isIOSDevice } from './audioGraph';

/**
 * 在 iOS 视频模式下设置影子音频（audio 与 video 同步播放，audio 静音）
 * @param {object} audioRef - audio 元素 ref
 * @param {object} videoRef - video 元素 ref
 * @param {Function} getStreamUrl - 获取流 URL
 * @param {object} currentMusic - 当前音乐
 * @param {object} [iosShadowAudioRef] - 影子音频状态 ref
 * @param {boolean} hasVideoInCurrentMusic - 当前音乐是否有视频
 * @returns {Promise<boolean>} 是否已设置
 */
export async function setupIosShadowAudio(audioRef, videoRef, getStreamUrl, currentMusic, iosShadowAudioRef, hasVideoInCurrentMusic) {
  if (!hasVideoInCurrentMusic || !isIOSDevice() || !audioRef?.current) return false;
  const streamUrl = getStreamUrl(currentMusic, 'webm');
  if (!streamUrl) return false;

  const audio = audioRef.current;
  const video = videoRef?.current;
  if (audio.src !== streamUrl) audio.src = streamUrl;
  if (video && !Number.isNaN(video.currentTime)) {
    try { audio.currentTime = video.currentTime; } catch (_) {}
  }
  audio.muted = false;
  audio.volume = 0;
  audio.playbackRate = 1.0;
  try { await audio.play(); } catch (_) {}
  if (iosShadowAudioRef) iosShadowAudioRef.current = true;
  return true;
}
